export default "__VITE_ASSET__B6T4Ebh8__"